export class Area {
    name: string;
    order: number;
    date: Date;
    createdBy: string;
    modifiedBy: string;
}
